export const M2_TO_FT2 = 10.7639;

export const useAreaFormat = () => {
  const preferences = usePreferencesStore();

  const formatArea = (valueM2: number): { value: number; suffix: string } => {
    const unit = unref(preferences.measureUnit);
    if (unit === 'ft2') {
      return { value: Math.round(valueM2 * M2_TO_FT2), suffix: 'ft²' };
    }
    return { value: Math.round(valueM2), suffix: 'm²' };
  };

  const areaSuffix = computed(() => (unref(preferences.measureUnit) === 'ft2' ? 'ft²' : 'm²'));

  return { formatArea, areaSuffix, measureUnit: computed(() => preferences.measureUnit) };
};
